import { render, staticRenderFns } from "./RidePage.vue?vue&type=template&id=06c7a7ed&scoped=true"
import script from "./RidePage.vue?vue&type=script&lang=js"
export * from "./RidePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7a7ed",
  null
  
)

export default component.exports